<template>
  <div class="menu-mobile" @click="$emit('close')">
    <div class="menu-content hidden-scrollbar">
      <div
        class="menu-item"
        :class="{ active: dropDownMap[navItem.type] }"
        v-for="(navItem, index) in mobileDropDownList"
        :key="index"
      >
        <div
          class="menu-item-title d-flex ai-center jc-between"
          @click.stop="onNavItem(navItem)"
        >
          <img class="icon" v-if="navItem.icon" :src="navItem.icon" />
          <div>{{ navItem.title }}</div>
          <img
            class="arrow-down"
            :class="{ active: dropDownMap[navItem.type] }"
            v-if="navItem.children"
            :src="arrowImg"
          />
          <div class="dark-mode-switch" v-if="navItem.darkMode">
            <Switcher :value="isDarkMode" @switch="changeMode" />
          </div>
        </div>
        <div class="cooperation-solution" v-if="navItem.type === 'forBusiness' && dropDownMap[navItem.type]">
          <div class="img-wrap">
            <img src="../../assets/images/header/For-Business/m-1.png" alt="" />
            <span class="desc">{{ $t('common.cooperationSolution') }}</span>
          </div>
          <span>{{ $t('common.cases') }}</span>
        </div>
        <div class="nav-item-list-box" v-if="dropDownMap[navItem.type]">
          <div
            class="nav-item"
            v-for="(subItem, index) in navItem.children"
            :key="index"
            @click="onSubtitle(navItem.type, subItem)"
          >
            <div class="nav-item-left">
              <img v-if="subItem.icon" :src="subItem.icon" alt="" />
              <div class="text-wrap">
                <div class="label-wrap" v-if="subItem.label">
                  <span>{{ subItem.label }}</span>
                  <img v-if="subItem.KeyPal_2" src="../../assets/images/keypal-two/two.png" alt="" />
                </div>
                <div class="desc-wrap" v-if="subItem.desc">
                  <span>{{ subItem.desc }}</span>
                </div>
              </div>
            </div>
            <div class="nav-item-right">
              <div class="language-icon" v-if="navItem.type === 'language'">
                <img v-if="subItem.lang === $i18n.locale" src="../../assets/images/header/selected.png" alt="" />
              </div>
              <img class="enter-icon" v-else :src="enterImg" alt="" />
            </div>
          </div>
        </div>
        <div class="contact-us" v-if="navItem.type === 'forBusiness' && dropDownMap[navItem.type]">
          <div class="contact-title">{{ $t('common.contactUs') }}</div>
          <div class="contact-item">
            <img :src="emailImg" alt="" />
            <a href="mailto:support@keypal.pro" target="_blank">support@keypal.pro</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { setMode } from "../../utils";
import Switcher from './Switcher.vue';
import navUrl from "../../mixins/navUrl";
export default {
  components: {
    Switcher,
  },
  mixins: [navUrl],
  data() {
    return {
      dropDownMap: {
        product: false,
        learn: false,
        apps: false,
        forBusiness: false,
        language: false,
      },
    };
  },
  computed: {
    ...mapGetters(['isDarkMode']),
    isZh() {
      return this.$i18n.locale === 'zh';
    },
    mobileDropDownList() {
      return [
        {
          title: this.$t('common.product'),
          type: 'product',
          children: [
            {
              label: 'KeyPal',
              KeyPal_2: true,
              icon: require(`../../assets/images/header/product/1.png`),
            },
            {
              label: 'KeyPal Plus',
              icon: require(`../../assets/images/header/product/2.png`),
              // routePath: '/keypalplus',
              url: location.origin + '/#keypalplus',
            },
            {
              label: this.$t('navigation.product.label_2'),
              icon: require(`../../assets/images/header/product/3.png`),
              // routePath: '/safebox',
              url: location.origin + '/#safebox',
            },
            {
              label: 'KeyPal Card',
              icon: require(`../../assets/images/header/product/4.png`),
              url: `https://card.keypal.pro/`,
            },
          ],
        },
        {
          title: this.$t('common.learn'),
          type: 'learn',
          children: [
            {
              icon: require(`../../assets/images/header/learn/1.png`),
              label: this.$t('navigation.learn.label_1'),
              desc: this.$t('common.information'),
              url: `https://card.keypal.pro/tutorials`,
            },
            {
              icon: require(`../../assets/images/header/learn/2.png`),
              label: 'KeyPal 2',
              desc: this.$t('common.tutorials'),
              routePath: `/keypal2/tutorial`,
            },
            {
              icon: require(`../../assets/images/header/learn/3.png`),
              label: 'KeyPal Plus',
              desc: this.$t('common.tutorials'),
              // routePath: '/academy',
              url: location.origin + '/#/academy',
            },
            {
              icon: require(`../../assets/images/header/learn/4.png`),
              label: 'KeyPal Card',
              desc: this.$t('common.tutorials'),
              url: `https://card.keypal.pro/tutorials`,
            },
          ],
        },
        {
          title: this.$t('common.apps'),
          type: 'apps',
          children: [
            {
              icon: require(`../../assets/images/header/apps/1.png`),
              label: this.$t('common.mobileWallet'),
              url: `https://tokenpocket.pro/`,
            },
            {
              icon: require(`../../assets/images/header/apps/2.png`),
              label: this.$t('common.extensionWallet'),
              url: `https://extension.tokenpocket.pro/`,
            },
            {
              icon: require(`../../assets/images/header/apps/3.png`),
              label: this.$t('common.KeyPal_2_firmware'),
              desc: this.$t('common.comingSoon'),
              // url: `https://tokenpocket.pro/`,
            },
            {
              icon: require(`../../assets/images/header/apps/4.png`),
              local: true,
              label: this.$t('common.KeyPal_Plus_firmware'),
              // routePath: '/keypalplus',
              url: location.origin + '/#/keypalplus',
            },
          ]
        },
        {
          title: this.$t('common.forBusiness'),
          type: 'forBusiness',
          children: [
            {
              // label: 'KeyPal x TRON',
              label: this.$t('common.comingSoon'),
              icon: require(`../../assets/images/header/For-Business/m-2.png`),
            },
            {
              // label: 'KeyPal x GoPlus',
              label: this.$t('common.comingSoon'),
              icon: require(`../../assets/images/header/For-Business/m-3.png`),
            },
          ],
        },
        {
          title: this.$t('common.support'),
          // url: this.isZh ? `https://keypal.gitbook.io/zh-cn` : `https://keypal.gitbook.io/en`
          url: this.supportUrl,
        },
        {
          title: this.$t('common.darkMode'),
          darkMode: true,
        },
        {
          title: this.$t('common.language'),
          type: 'language',
          children: [
            { label: 'English', lang: 'en' },
            { label: '中文(简体)', lang: 'zh' },
            { label: '中文(繁体)', lang: 'zh-tw' },
            { label: '日本語', lang: 'ja' },
            { label: '한국어', lang: 'ko' },
            { label: 'Français', lang: 'fr' },
            { label: 'Español', lang: 'es' },
          ],
        },
      ];
    },
    emailImg() {
      return require(`../../assets/images/header/For-Business/email${this.darkModeImg}.png`);
    },
    enterImg() {
      return require(`../../assets/images/header/learn/arrow${this.darkModeImg}.png`);
    },
    arrowImg() {
      return require(`../../assets/images/keypal-two/arrow${this.darkModeImg}.png`);
    },
  },
  mounted() {
    // 监听，除了点击自己，点击其他地方将自身隐藏
    // document.addEventListener('click', this.onOutside)
  },
  methods: {
    changeMode() {
      this.$store.commit('setDark', !this.isDarkMode)
      setMode(this.isDarkMode)
      localStorage.setItem('theme', this.isDarkMode ? 'dark' : 'light')
    },
    onOutside(e) {
      const languageBtn = this.$refs.languageBtn;
      if (!languageBtn.contains(e.target)) {
        const contentWrap = document.querySelector('.menu-content');
        if (contentWrap) {
          if (!contentWrap.contains(e.target)) {
            this.isShowLanguageBox = false;
            this.isShowLanguageListBox = false;
          }
        }
      }
    },
    onNavItem(navItem) {
      if (navItem.url) {
        let target = '_blank'
        if (navItem.local) {
          target = '_self'
        }
        window.open(navItem.url, target);
      } else if (navItem.children) {
        this.dropDownMap[navItem.type] = !this.dropDownMap[navItem.type];
      } else if (navItem.lang) {
        this.$i18n.locale = navItem.lang;
      } else if (navItem.routePath) {
        this.$router.push({ path: navItem.routePath });
      }
    },
    onSubtitle(type, subItem) {
      if (subItem.url) {
        let target = '_blank'
        if (subItem.local) {
          target = '_self'
        }
        window.open(subItem.url, target);
      } else if (type === 'language') {
        this.$i18n.locale = subItem.lang;
      } else if (subItem.routePath) {
        this.$router.push({ path: subItem.routePath });
      }
    },
    onChangeLang(e) {
      // this.$store.commit('changeLanguage', e.target.dataset.lang)
      if (e.target.dataset.lang) {
        console.log('e', e.target.dataset.lang);
      }
    },
    openUrl(url, index) {
      if (index === 1) {
        window.open(url, '_self');
      } else {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-mobile {
  position: fixed;
  z-index: 9997;
  top: 50px;
  left: 0;
  width: 100vw;
  height: calc(100vh - 50px);
  background: var(--bg-7);
  .menu-content {
    height: 100%;
    margin: 0 16px;
    padding-top: 20px;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    gap: 24px 0;
    overflow: auto;
    .menu-item {
      color: var(--color-1);
      font-size: 16px;
      font-weight: 500;
      &.active {
        padding: 16px;
        background: var(--bg-8);
        border-radius: 16px;
      }
      .menu-item-title {
        .icon {
          margin-right: 7px;
          width: 13px;
          height: 13px;
        }
        .arrow-down {
          transform-origin: center center;
          transform: rotate(90deg);
          width: 26px;
          height: 26px;
          &.active {
            transform: rotate(-90deg);
          }
        }

        .dark-mode-switch {
          ::v-deep .switch-wrap {
            display: flex;
            justify-content: flex-end;
            .weui-switch {
              width: 34px;
              height: 20px;
              border-radius: 20px;
              &::before {
                width: 32px;
                height: 18px;
                border-radius: 20px;
              }
              &::after {
                width: 18px;
                height: 18px;
                border-radius: 20px;
              }
            }
            .weui-switch-on:after {
              transform: translateX(13px);
            }
          }
        }
      }

      .cooperation-solution {
        margin-top: 12px;
        padding: 0 0 12px 0;
        display: flex;
        flex-direction: column;
        gap: 16px 0;
        .img-wrap {
          position: relative;
          img {
            width: 100%;
            height: auto;
          }
          span {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 16px;
            color: #fff;
          }
        }
      }

      .nav-item-list-box {
        margin-top: 12px;
        display: flex;
        flex-direction: column;
        gap: 24px 0;
        .nav-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .title {
            height: 45px;
            text-align: center;
            font-size: 14px;
          }
          .nav-item-left {
            display: flex;
            align-items: center;
            gap: 0 8px;
            img {
              width: 56px;
              height: 56px;
            }
            .text-wrap {
              .label-wrap {
                display: flex;
                align-items: center;
                gap: 0 4px;
                span {
                  font-size: 14px;
                  color: var(--color-1);
                }
                
                img {
                  width: 13px;
                  height: 13px;
                }
              }
              .desc-wrap {
                span {
                  font-size: 12px;
                  color: var(--color-3);
                }
              }
            }
          }

          .nav-item-right {
            .language-icon {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 16px;
              height: 16px;
              img {
                width: 14px;
                height: 10px;
              }
            }
            .enter-icon {
              width: 16px;
              height: 16px;
            }
          }
        }

        .language-item {
        }
      }
      .contact-us {
        margin-top: 24px;
        font-size: 13px;
        font-weight: 600;
        color: var(--color-1);
        display: flex;
        flex-direction: column;
        gap: 16px 0;
        .contact-item {
          display: flex;
          align-items: center;
          gap: 0 8px;
          img {
            width: 20px;
            height: 20px;
          }
          a {
            font-size: 14px;
            color: var(--color-1);
          }
        }
      }
    }
  }
}

@media screen and (min-width: 767px) {
  .menu-mobile {
    .menu-content {
      margin: 0 32px;
    }
  }
}
</style>
